export default "<app-sub-page-tap-content></app-sub-page-tap-content>\n"